// 判断类型枚举
export enum JudgeType {
    INFO = 1, // 提取的信息
    SYSTEM = 2, // 系统变量
    CUSTOM = 3, // 自定义变量
  }

// 判断条件枚举
export enum ConditionMode {
  CONTAIN = 1, // 包含
  NOT_CONTAIN = 2, // 不包含
  EQUAL = 3, // 等于
  NOT_EQUAL = 4, // 不等于
  IS_NULL = 5, // 为空
  NOT_NULL = 6, // 不为空
}

// 匹配模式枚举
export enum MatchMode {
  AI = 1, // AI智能判断
  RULE = 2, // 规则模式
}

// 条件组模式枚举
export enum BranchMode {
  AI = 0, // AI智能判断
  AND = 1, // 并且
  OR = 2, // 或者
  ELSE = 3, // 兜底分支
}

export interface Condition {
  type: JudgeType;
  info_id: string;
  mode: ConditionMode;
  content: string;
}

export interface Branch {
  id: string;
  name: string;
  mode: BranchMode;
  conditions: Condition[];
  condition?: Array<any>;
  content?: string;
  originContent?: string;
  urlStatus?: 0 | 1;
  url?: string
  type?:number
}

export interface ConditionJudgeData {
  matchMode: MatchMode;
  branches: Branch[];
}

export interface Variable {
  value: string | JudgeType;
  label: string;
  type: string | JudgeType;
  children?: Variable[];
  id?: string;
}

export interface InfoOption {
  value: string;
  label: string;
  tip: string;
  showButton?: boolean;
  childLabel?: string;
  sourceType?: JudgeType; // 1: 信息收集节点, 3: 接口调用节点
}



// 校验是否含有类似 '${xxx-xxx}' 的字符串,前面的$ 中间的- 都是必有的
export const hasInfoOrVariable = (content: string) => {
  const regex = /\$\{([123])-[^}]+\}/;
  return regex.test(content);
};

export const hasEmptyInfoOrVariable = (content: string) => {
  const regex = /\$\{([123])-}/;
  return regex.test(content);
};
